<template>
<div>
	<nav class="navbar navbar-expand-md fixed-top navbar-dark bg-dark">
		<a class="navbar-brand" href="#">阿敦信息科技</a>
		<button class="navbar-toggler" aria-expanded="false" aria-controls="navbarsExampleDefault" aria-label="Toggle navigation" type="button" data-toggle="collapse" data-target="#navbarsExampleDefault">
		<span class="navbar-toggler-icon"></span>
		</button>
		<div class="collapse navbar-collapse" id="navbarsExampleDefault" >
			<ul class="navbar-nav mr-auto">
				<li class="nav-item active">
					<router-link class="nav-link" to='/'>主页 »<span class="sr-only">(current)</span></router-link>
				</li>
				<li class="nav-item dropdown">
					<a class="nav-link dropdown-toggle" id="dropdown01" aria-expanded="false" aria-haspopup="true" href="#" data-toggle="dropdown">公司命名工具</a>
					<div class="dropdown-menu" aria-labelledby="dropdown01">
						<router-link class="dropdown-item" to='/companyName'><el-icon class="el-icon-news" style="margin: 10px;"/>电脑版</router-link>
						<router-link class="dropdown-item" to='/displayCompanyName'><el-icon class="el-icon-mobile-phone" style="margin: 10px;"/>手机版</router-link>
					</div>
				</li>
				<li class="nav-item dropdown">
					<a class="nav-link dropdown-toggle" id="dropdown01" aria-expanded="false" aria-haspopup="true" href="#" data-toggle="dropdown">资源</a>
					<div class="dropdown-menu" aria-labelledby="dropdown01">
						<a class="dropdown-item" href="/static/pdf/adun.pdf" download="adun.pdf" target="_blank"><i class="el-icon-document" style="margin: 10px;"></i>宣传手册</a>
						<a class="dropdown-item" href="https://blog.csdn.net/java_augur/article/details/119895403" target="_blank"><el-icon class="el-icon-news" style="margin: 10px;"/>技术框架</a>
						<a class="dropdown-item" href="https://adun.live:8443/svn" target="_blank"><el-icon class="el-icon-date" style="margin: 10px;"/>内部资料</a>
						<a class="dropdown-item" href="https://mail.adun.live" target="_blank"><el-icon class="el-icon-message" style="margin: 10px;"/>网上邮箱</a>
					</div>
				</li>
				<li class="nav-item">
					<router-link class="nav-link" to="/contactView">联系我们</router-link>
				</li>
			</ul>
		</div>
	</nav>
	<transition>
		<keep-alive>
			<router-view></router-view>
		</keep-alive>
	</transition>
	<div id="footerBanner">
		<div class="row" style="margin: 0;">
			<div class="col-md-4" style="text-align:center;">
				<el-row style="margin: 20px;font-size:1em">联系方式</el-row>
				<el-row>手机：+86 13621759658</el-row>
				<el-row style="display: none;">垃圾邮箱：aaa_spam@adun.live</el-row>
				<el-row>邮箱：admin@adun.live</el-row>
				<el-row>地址：上海浦东新区青桐路408弄3号楼1003室</el-row>
			</div>
			<div class="col-md-4" style="text-align:center;">
				<el-row style="margin: 20px;font-size:1em">快速链接</el-row>
				<el-row><a href="https://www.jhipster.tech/" class="footlink"  target="_blank">jhipster开发平台</a></el-row>
				<el-row><a href="https://blog.csdn.net/java_augur/article/details/119895403"  target="_blank" class="footlink">相关技术文章</a></el-row>
			</div>
			<div class="col-md-4" style="text-align:center;">
				<el-row style="margin: 20px;font-size:1em">预定演示</el-row>
				<el-row><a href="mailto:admin@adun.live?subject=免费试用请求&body=" rel="nofollow" class="footlink">免费试用请求</a></el-row>
				<el-row><a href="mailto:feng.guan@adun.live?subject=产品升级&body=" rel="nofollow" class="footlink">产品升级</a></el-row>
			</div>
		</div>
	</div>
	<footer style="text-align: center; font-size: 0.6em">
		<el-row>主办单位名称: 上海阿敦信息科技有限公司</el-row>
		<el-row>网站名称: 阿敦信息科技有限公司</el-row>
		<el-row>网站首页网址: www.adun.live</el-row>
		<el-row>© Shanghai Adun Information Technology Limted. 2018</el-row>
		<el-row>
			<a href="http://beian.miit.gov.cn"  target="_blank">网站备案/许可证号: 沪ICP备18018838号-1</a>
		</el-row>
	</footer>
</div>
</template>
<script>
export default {
  name: 'app',
  data () {
    return {
      link: 'link'
    }
  }
}
</script>
<style scoped>
#footerBanner {
	background: url(../static/assets/image/footer.jpg) no-repeat 50% 50%;
	background-size: cover;
	width: 100%;
	overflow:auto;
	color: white;
	height: 200px;
}
a.footlink:link, a.footlink:visited {
	color: white;
}
</style>



// WEBPACK FOOTER //
// src/App.vue